<span [ngClass]="{'top': hasUnderline}" [ngStyle]="text.style">
  <span *ngIf="text.type === 'TEXT'">{{text.text}}</span>
  <span *ngIf="text.type === 'LINK'">
    <a [href]="text.data.url" [target]="text.data.target" (click)="handleClick($event)">{{text.text}}</a>
  </span>
</span>
